// @core/api/endpoints/document/get_document_policy.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  DocumentPolicyResponse,
} from '../../../types/document';

const BASE_PATH = '/document';

/**
 * Get policy
 * Returns a document policy by ID.
 */
export async function GetDocumentPolicy(
  policy_id: string,
  options?: RequestOptions
): Promise<DocumentPolicyResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/document-policies/:policy_id`;
  requestPath = requestPath.replace(':policy_id', encodeURIComponent(policy_id));
  const requestOptions = options;
  return client.get<DocumentPolicyResponse>(requestPath, { ...requestOptions });
}
